/**
 * TOBIE scroll engine.
 *
 * Shared by every scroll-driven Tobie effect (footer smoke, floating objects).
 *
 * The theme scrolls in two different places: on desktop (>= 990px) the page
 * scrolls inside `.page-wrapper`; on mobile it scrolls the window. Effects
 * must not care, so they subscribe here (one captured scroll listener covers
 * both) and read progress from bounding boxes.
 *
 *   const off = TobieScroll.subscribe(() => { ... });   // returns unsubscribe
 *   TobieScroll.progress(el)                            // 0..1, see below
 */
(() => {
  if (window.TobieScroll) return;

  const subscribers = new Set();
  let queued = false;
  let listening = false;

  function notify() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      subscribers.forEach((fn) => fn());
    });
  }

  // `scroll` does not bubble, but it can be captured at the document. That
  // covers the window and `.page-wrapper` alike, whichever is scrolling.
  function listen() {
    if (listening) return;
    listening = true;
    document.addEventListener('scroll', notify, { capture: true, passive: true });
    window.addEventListener('resize', notify, { passive: true });
  }

  window.TobieScroll = {
    subscribe(fn) {
      listen();
      subscribers.add(fn);
      notify();
      return () => subscribers.delete(fn);
    },

    /**
     * How far `el` has travelled into view: 0 while its top edge is at or
     * below the viewport bottom, 1 once its full height has entered.
     */
    progress(el) {
      const rect = el.getBoundingClientRect();
      const height = rect.height || 1;
      const p = (window.innerHeight - rect.top) / height;
      return Math.min(1, Math.max(0, p));
    },

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },
  };
})();
